export default "__VITE_ASSET__67c7bf75__"